import { graphql } from "react-relay";

// internal
import { HomeSlack } from "./WebAppSlack";

// components
import "@components/login-btn/LoginBtn.gql";

export const webAppSlackFragments = {
  viewer: graphql`
    fragment WebAppSlack_viewer on Viewer {
      ...LoginBtn_viewer
      verificationCodeResponse {
        verificationType
        verificationCode
        verificationAttempted
        valid
        slackTeam
      }
      user {
        id
        orgs(first: 1000000) {
          edges {
            node {
              id
            }
          }
        }
      }
    }
  `,
};

export const webAppSlackQuery = graphql`
  query WebAppSlackQuery {
    viewer {
      ...WebAppSlack_viewer
    }
  }
`;
